import { addOpacityToHex, Colors } from '@utils/color';

export const DEFAULT_SHEET_PROPERTIES = Object.freeze({
  snapPoints: [1, 0.75, 0.5, 0.25, 0],
  initialSnap: 1,
  style: {
    borderTopRightRadius: '2rem',
    borderTopLeftRadius: '2rem',
  },
  backdropStyle: {
    backgroundColor: addOpacityToHex(Colors.black, 0.3),
  },
});
